export default __webpack_public_path__ + "static/media/panel.ed8e6fcf.svg";